import { Checkbox } from "@/components/atoms/Checkbox/checkbox"
import { HeadingText } from "@/components/atoms/HeadingText/heading-text"
import { Label } from "@/components/atoms/Label/label"
import React from "react"
import { Check } from "lucide-react"

type Option = {
  id: string
  label: string
}

type GroupCheckboxProps = {
  options: Option[]
  selectedOptions?: string[] // Optional, with default below
  onChange?: (newSelected: string[]) => void
  list: boolean
  label: string
  dashboardInput: boolean
}

const GroupCheckBox = React.forwardRef<HTMLDivElement, GroupCheckboxProps>(({
  label,
  options,
  selectedOptions = [],
  onChange,
  list,
  dashboardInput,
}, ref) => {
  // Toggle selection and call the onChange with updated array
  const handleToggle = (id: string) => {
    if (!onChange) return
    const isSelected = selectedOptions.includes(id)
    const newSelected = isSelected ? selectedOptions.filter((item) => item !== id) : [...selectedOptions, id]
    onChange(newSelected)
  }

  return (
    <div ref={ref} className="my-6 flex flex-col" tabIndex={-1}>
      {!list && label && <HeadingText level={4}>{label}</HeadingText>}
      <div className={dashboardInput ? "grid gap-4 py-5 md:grid-cols-4" : "grid grid-cols-2 gap-4 py-5"}>
        {options.map((option) => (
          <Label
            key={option.id}
            className={
              list
                ? "flex items-center gap-2 font-semibold text-gray-700 dark:text-gray-300"
                : "flex items-center gap-2 font-normal text-gray-500 dark:text-gray-300"
            }
          >
            {!list && onChange ? (
              <Checkbox
                name={option.id}
                checked={selectedOptions.includes(option.id)}
                onCheckedChange={() => handleToggle(option.id)}
              />
            ) : (
              <Check size={25} />
            )}
            <span>{option.label}</span>
          </Label>
        ))}
      </div>
    </div>
  )
})

export default GroupCheckBox
